import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-billdetails',
  templateUrl: './billdetails.component.html',
  styleUrls: ['./billdetails.component.css']
})
export class BilldetailsComponent implements OnInit {

  index: any = 1;

  urlname: any = "";

  companyBO: any = {}
  salesmainBO: any = {};
  salesdetailsColl: any = [];
  summaryColl: any = [];
  salespayColl: any = [];
  receiptsettingsBO: any = {};


  routerEventSubscription = Subscription.EMPTY;

  constructor(public loginService: LoginDataService, public router: Router, private appService: DhukanDataService, private cuurenctRoute: ActivatedRoute) {
    this.routerEventSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.fnGetUrlParameters()
      });

  }

  fnGetUrlParameters() {
    this.urlname = this.cuurenctRoute.snapshot.paramMap.get('urlname');

    if (this.urlname !== "") {
      this.fnGetSalesDetails();
    }
  }



  ngOnInit() {

  }

  ngOnDestroy(): void {
    if (this.routerEventSubscription !== undefined) {
      this.routerEventSubscription.unsubscribe();
    }
  }


  fnGetSalesDetails() {
    var data = {
      'urlname': this.urlname,
    }
    this.appService.getSalesDetailsByEbill(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            var result = res.json().result;
            console.log(result)
            if (result.length > 0) {
              if (result[0].length > 0) {
                this.companyBO = result[0][0]
              }
              let salesmainColl = result[1];
              this.salesmainBO = salesmainColl[0];
              this.salesdetailsColl = result[2];
              this.summaryColl = result[3];

              this.salespayColl = result[4];


              let receiptsettingsColl = result[5];
              this.receiptsettingsBO = receiptsettingsColl[0];



              var data = {
                salesid: this.salesmainBO.salesid,
                printername: "",
                companyname: this.companyBO.companyname,
                receiptheadername: "",
                salesmaindata: salesmainColl,
                salesdetailsdata: this.salesdetailsColl,
                salespaydata: this.salespayColl,
                summarydata: this.summaryColl,
                receiptsettingsdata: this.receiptsettingsBO,
                companydetailsdata: this.companyBO,
                printersettingsdata: [],
                companysettingsdata: [],
                stationname: ""
              }


              var receiptdata=this.fnGetReceiptContentNew(data)

              //console.log(receiptdata)

              document.getElementById("receiptcontent").innerHTML=receiptdata;
            }

          }
          else if (res.json().status == 400) {
            // this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {

          //this.toastr.error('Error', err);
        })
  }


  fnGetReceiptContentNew(data) {

    var receiptheadername = ""
    var salesmaindata: any = {}
    var salesdetailsdata = []
    var salespaydata = []
    var summarydata: any = {}
    var receiptsettingsdata: any = {}
    var companydetailsdata: any = {}

    var marginleft = 0;
    var marginright = 0;

    receiptheadername = data.receiptheadername
    if (data.salesmaindata.length > 0) {
      salesmaindata = data.salesmaindata[0]
    }
    salesdetailsdata = data.salesdetailsdata

    if (data.summarydata.length > 0) {
      summarydata = data.summarydata[0]
    }
    salespaydata = data.salespaydata

    receiptsettingsdata = data.receiptsettingsdata

    companydetailsdata = data.companydetailsdata

    if (data.printersettingsdata != null) {
      marginleft = data.printersettingsdata.marginleft
      marginright = data.printersettingsdata.marginright
    }

    //Company Settings
    let enabletokennoinfooter = '';
    let enablecustomeraddressinbill = '';
    let tokennodisplayname = '';

    if (data.companysettingsdata.length > 0) {
      for (let abo of data.companysettingsdata) {
        if (abo.settingsname === 'ENABLE_TOKENNO_IN_FOOTER') {
          enabletokennoinfooter = abo.settingsvalue;
        }
        else if (abo.settingsname === 'ENABLE_CUSTOMER_ADDRESS_IN_BILL') {
          enablecustomeraddressinbill = abo.settingsvalue;
        }
        else if (abo.settingsname === 'TOKENNO_DISPLAYNAME') {
          tokennodisplayname = abo.settingsvalue;
        }


      }
    }

    //var current_time = dateFormat(new Date(), "dd-mm-yyyy hh:MM:ss TT")

    var current_time = ""


    var fontfamily = ""
    if (this.fnaaFormatString(receiptsettingsdata.font) !== "" && this.fnaaFormatString(receiptsettingsdata.font) !== null) {
      fontfamily = this.fnaaFormatString(receiptsettingsdata.font);
    }
    else {
      fontfamily = "Verdana"
    }

    if (fontfamily === "") {
      fontfamily = "Verdana"
    }


    var kotContent =
      '<html><head></head><body>' +
      '<div id="main_div_draggable" style="width:280px;margin:0px ' + this.fnFormatInt(marginright) + 'px 0px ' + this.fnFormatInt(marginleft) + 'px;font-size:13px;font-family:' + fontfamily + ';">' +
      this.fnLogoHeader(receiptsettingsdata.receiptimg) +
      '<div style="width:100%;text-align: center;float:left;">' +
      this.fnDuplicateHeader(salesmaindata) +
      '<div style="font-size:14px;font-weight:900;margin:5px 0">' + receiptsettingsdata.restaurantname + '</div>' +
      this.fnAddressTemplate(receiptsettingsdata.address1) + this.fnAddressTemplate(receiptsettingsdata.address2) +
      this.fnAddressTemplate(receiptsettingsdata.address3) + this.fnAddressTemplate(receiptsettingsdata.address4) + this.fnAddressTemplate(receiptsettingsdata.address5) +
      this.fnAddressTemplate(receiptsettingsdata.header1) + this.fnAddressTemplate(receiptsettingsdata.header2) +
      this.fnAddressTemplate(receiptsettingsdata.header3) + this.fnAddressTemplate(receiptsettingsdata.header4) + this.fnAddressTemplate(receiptsettingsdata.header5) +
      this.fnGSTNoTemplate(companydetailsdata.gstno, receiptsettingsdata.enablegstno) + this.fnFSSAITemplate(companydetailsdata.fssaino, receiptsettingsdata.enablefssaino) +
      '<div style="font-weight:600;margin-bottom:5px;margin-top:3px;">' + receiptsettingsdata.receipttitle + '</div>' +
      '<div style="font-weight:900;margin-bottom:0px;">' + this.fnDineTypeTemplate(salesmaindata) + '</div>' +
      this.fnReceiptCancelledTemp(salesmaindata) + this.fnCustomerTemplate(salesmaindata, enablecustomeraddressinbill) +
      this.fnLineTemplate() +
      '<div style="width:100%;margin: 2px 0;float:left;text-align:left;font-size:13">' +
      '<div style="width:100%;float:left;">' +
      '<div style="width:50%;float:left;">Bill No: <b style="font-size:14px; font-weight:600">' + salesmaindata.billno + '</b></div>' +
      '<div style="width:50%;float:right;text-align:right;">Date:  ' + salesmaindata.salesdate + '</div>' +
      '</div>' +
      '<div style="width:100%;float:left;">' +
      '<div style="width:50%;float:left;">' + this.fnTableNoTokenNoOrderNo(salesmaindata, tokennodisplayname) + '</div>' +
      '<div style="width:50%;float:right;text-align:right;">Time:  ' + salesmaindata.ordertime + '</div>' +
      '</div>' +
      '<div style="width:100%;float:left;">' +
      '<div style="width:50%;float:left;">Waiter: ' + this.fnaaFormatString(salesmaindata.waitername )+ '</div>' +
      '<div style="width:50%;float:right;text-align:right;"> ' + this.fnNoOfPerson(salesmaindata) + '</div>' +
      '</div>' +
      '<div style="width:100%;float:left;">' +
      '<div style="width:50%;float:left;">Cashier: ' +this.fnaaFormatString( salesmaindata.createduser) + '</div>' +
      '<div style="width:50%;float:right;text-align:right;"></div>' +
      '</div>' +
      '<div style="float:left;"></div>' +
      '<div style="float:left;"></div>' +
      '</div>' +
      this.fnLineTemplate() +
      '<div style="width:100%;min-height:0px;">' +
      '<table style="width:100%;font-size: var(--font13);font-family:' + fontfamily + ';" cellspacing="0" cellpadding="0">' +
      '<tbody>' +
      '<tr style="margin:0;padding:0;">' +
      '<td style="text-align:left">Item</td>' +
      '<td style="width:20px;" align="center">Qty.</td>' +
      '<td style="width:40px;" align="right">Price</td>' +
      '<td style="width:55px;" align="right">Amount</td>' +
      '</tr>' +
      '<tr style="margin:0;padding:0;">' +
      '<td colspan="4" >' +
      this.fnLineTemplate() +
      '</td>' +
      '</tr>' + this.fnReceiptDetailsLoop(salesdetailsdata) +
      '</tbody>' +
      '</table>' +
      '</div>' +
      '<div>' +
      '<table style="width:100%;font-size: var(--font13);font-family:' + fontfamily + ';" cellspacing="0" cellpadding="0">' +
      '<tbody>' +
      '<tr>' +
      '<td colspan="3">' +
      this.fnLineTemplate() +
      '</td>' +
      '</tr>' +
      '<tr style="margin:0;padding:0;">' +
      '<td align="left">Total Qty: ' + summarydata.quantity + '</td>' +
      '<td align="right">Sub Total:</td>' +
      '<td align="right">' + this.aaNumber(summarydata.subtotal) + '</td>' +
      '</tr>' +
      this.fnSummaryAmountTemplate(summarydata.cgsttaxamt, 'CGST    :') +
      this.fnSummaryAmountTemplate(summarydata.sgsttaxamt, 'SGST    :') +
      this.fnSummaryAmountTemplate(salesmaindata.chargestotal, 'Charges :') +
      this.fnSummaryAmountTemplate(salesmaindata.discamt, 'Discount:') +
      this.fnSummaryAmountTemplate(salesmaindata.roundoff, 'RoundOff:') +
      '</tbody>' +
      '</table>' +
      '</div>' +
      '<div style="margin:5px 0;">' +
      '<table style="width:100%;font-family:' + fontfamily + ';" cellspacing="0" cellpadding="0">' +
      '<tbody>' +
      '<tr style="margin:0;padding:0;">' +
      '<td align="right" colspan="2"><span style="font-size:12px; font-weight:bold"> Grand Total :</span>' +
      '<b style="font-size:18px; font-weight:900; margin:3px 0">' + this.aaNumber(salesmaindata.grandtotal) + '</b></td>' +
      '</tr>' +
      '<tr style="margin:0;padding:0;font-size:10px;">' +
      '<td></td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '</div>' +
      this.fnLineTemplate() +
      this.fnKotNoTemplate(summarydata) +
      this.fnPaymentTemplate(salespaydata, fontfamily) +
      this.fnLineTemplate() +
      this.fnTokenNoFooter(salesmaindata, enabletokennoinfooter, tokennodisplayname) +
      this.fnAddressTemplate(receiptsettingsdata.footer1) + this.fnAddressTemplate(receiptsettingsdata.footer2) + this.fnAddressTemplate(receiptsettingsdata.footer3) +
      this.fnAddressTemplate(receiptsettingsdata.footer4) + this.fnAddressTemplate(receiptsettingsdata.footer5) +
      '<div style="font-weight:0;margin:5px 0;">' + this.fnPrinterOn(salesmaindata, current_time) + '</div>' +
      '</div>' +
      '</div>' +
      '</body></html>';

    return kotContent;

  }


  fnReceiptDetailsLoop(kotdetailsdata) {
    var printContents = ''
    for (let abo of kotdetailsdata) {

      if (abo.productsize === 'null') {
        abo.productsize = '';
      }

      printContents = printContents + '<tr style="margin:0;padding:0;vertical-align: top">' +
        '<td style="padding-bottom:5px;" align="left">' + abo.productname + ' ' + abo.productsize + '</td>' +
        '<td align="center" style="padding-bottom:5px;">' + abo.quantity + '</td>' +
        '<td align="right" style="padding-bottom:5px;">' + this.aaNumber(abo.unitprice) + '</td>' +
        '<td align="right" style="padding-bottom:5px;">' + this.aaNumber(abo.subtotal) + '</td>' +
        '</tr>';



      if (abo.modifierstatus !== '' && abo.modifiertxt !== '') {


        var mColl = JSON.parse(abo.modifiertxt);
        if (mColl) {
          if (mColl.length > 0) {
            for (let mbo of mColl) {
              printContents = printContents + '<tr style="margin:0;padding:0;vertical-align: top;">' +
                '<td style="padding-bottom:5px; font-size:10px;"> ..' + mbo.modifiername + '</td>' +
                '<td align="center"style="padding-bottom:5px;font-size:10px;">' + this.fnFormatInt(mbo.quantity) + '</td>' +
                '<td align="right" style="padding-bottom:5px;font-size:10px;">' + this.aaNumber(mbo.unitprice) + '</td>' +
                '<td align="right" style="padding-bottom:5px;font-size:10px;">' + this.aaNumber(mbo.upwoamttax) + '</td>' +
                '</tr>';

            }
          }
        }



      }


      // printContents = printContents +
      //     '<tr style="margin:0;padding:0;vertical-align: top">' +
      //     '<td style="padding-bottom:5px;">' + abo.productname + '</td>' +
      //     '<td align="center" style="padding-bottom:5px;">' + abo.quantity + '</td>' +
      //     '<td align="right" style="padding-bottom:5px;">' + abo.unitprice + '</td>' +
      //     '<td align="right" style="padding-bottom:5px;">' + abo.subtotal + '</td>' +
      //     '</tr>'
    }

    return printContents;
  }


  fnReceiptCancelledTemp(salesmaindata) {
    var printContents = ''
    if ( salesmaindata.iscancelled === 1) {

      printContents = '<div style="width:100%;text-align:center;float:center;font-size:13">Cancelled Bill&nbsp;</div>' + this.fnLineTemplate();

    }


    return printContents;
  }
  fnLineTemplate() {
    return '<hr style="margin:0px 0;border-bottom:#ccc dashed 1px;" />';
    //return '<hr style="border-style:das;">';

    // return '<div style="height:0.5px;background-color:black;"> </div>'


    // return '<hr style="border-style:solid;border-width:0.5px;">';
  }

  fnAddressTemplate(data) {
    var printContents = ''
    if (this.fnaaFormatString(data) !== '') {
      printContents = '<div style="font-size:12px;">' + data + '</div>'
    }
    return printContents;
  }

  fnGSTNoTemplate(data, isenable) {
    var printContents = ''
    if (data !== '' && this.fnFormatInt(isenable) === 1) {
      printContents = '<div style="font-size:12px;">GST:' + data + '</div>'
    }
    return printContents;
  }

  fnFSSAITemplate(data, isenable) {


    var printContents = ''
    if (data !== '' && this.fnFormatInt(isenable) === 1) {
      printContents = '<div style="font-size:12px;">FSSAI:' + data + '</div>'
    }
    return printContents;
  }

  fnCustomerTemplate(data, enablecustomeraddressinbill) {
    var printContents = ''
    if (this.fnaaFormatString( data.partyname) !== '') {
      printContents = this.fnLineTemplate()
      printContents = printContents + '<div style="width:100%;text-align:left;float:left;font-size:13;">Name:&nbsp;' + data.partyname + '</div>';
      // '<div style="float:left;width:100%;text-align:left;font-size:13;margin-bottom:5px;">'+data+'</div>';
    }
    if (this.fnaaFormatString(data.mobileno) !== '' && this.fnaaFormatString(data.mobileno) !== '0') {
      printContents = printContents + '<div style="width:100%;text-align:left;float:left;font-size:13;">Mobile:&nbsp;' + data.mobileno + '</div>';
    }

    if (this.fnaaFormatString(data.address1) !== '' && this.fnaaFormatString(enablecustomeraddressinbill) === "Yes") {
      printContents = printContents + '<div style="width:100%;text-align:left;float:left;font-size:13;">Address:&nbsp;' + data.address1 + '</div>';
    }

    return printContents;
  }


  fnTokenNoFooter(data, enabletokennoinfooter, tokennodisplayname) {
    var printContents = ''
    // console.log('----Token No---')
    // console.log(data);
    // console.log(enabletokennoinfooter)

    if (data.dinetypelist === 'TAKEAWAY' && enabletokennoinfooter === "Yes") {
      if (tokennodisplayname !== '') {
        printContents = '<div style="margin:5px 0;">' +
          '<table style="width:100%;font-family:Verdana;" cellspacing="0" cellpadding="0">' +
          '<tbody>' +
          '<tr style="font-weight:900;margin:0;padding:0;font-size:16px;">' +
          '<td align="center">' + tokennodisplayname + ':' + data.tokenno + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '</div>'
      }
      else {
        printContents = '<div style="margin:5px 0;">' +
          '<table style="width:100%;font-family:Verdana;" cellspacing="0" cellpadding="0">' +
          '<tbody>' +
          '<tr style="font-weight:900;margin:0;padding:0;font-size:16px;">' +
          '<td align="center">Token No:' + data.tokenno + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '</div>'
      }

      printContents = printContents + this.fnLineTemplate();
    }
    return printContents;

  }


  fnDineTypeTemplate(data) {
    var printContents = ''
    if (data.ordermodeid > 0) {
      printContents = data.dinetypename + ' [' + data.ordermodename + ']';
    }
    else {
      printContents = data.dinetypename;
    }
    return printContents;
  }

  fnTableNoTokenNoOrderNo(data, tokennodisplayname) {
    var printContents = ''
    if (data.dinetypelist === 'DINEIN') {
      printContents = 'Table No:' + data.tableno;
    }
    else if (data.dinetypelist === 'TAKEAWAY') {
      if (tokennodisplayname !== '') {
        printContents = tokennodisplayname + ':' + data.tokenno;
      }
      else {
        printContents = 'Token No:' + data.tokenno;
      }

    }
    else if (data.dinetypelist === 'ONLINE') {
      printContents = 'Order Id:' + data.onlineorderno;
    }
    else if (data.dinetypelist === 'DELIVERY') {
      printContents = 'Delivery';
    }
    return printContents;
  }

  fnNoOfPerson(data) {
    var printContents = ''
    if (data.dinetypelist === 'DINEIN') {
      printContents = 'No.of PAX:' + data.tableheadcount;
    }

    return printContents;
  }


  fnSummaryAmountTemplate(data, header) {
    var printContents = ''
    if (data !== 0 && data !== null) {
      printContents = '<tr style="margin:0;padding:0;">' +
        '<td align="left"></td>' +
        '<td align="right">' + header + '</td>' +
        '<td align="right">' + this.aaNumber(data) + '</td>' +
        '</tr>';
    }

    return printContents;
  }

  fnKotNoTemplate(summaryBO) {

    if (summaryBO.kotno === null) {
      summaryBO.kotno = '';
    }
    var printContents = 'Kot No: '

    printContents = printContents + summaryBO.kotno;

    console.log(printContents);
    // const filterPipe = new GroupbyPipe();
    // const fiteredArr = filterPipe.transform(detailsColl, "kotno");
    //console.log(fiteredArr)
    // for (let abo of fiteredArr) {
    //     printContents = printContents + abo.key + ","
    // }


    printContents = '<div style="width:100%;text-align:left;float:left;font-size:13;margin:0 0 2px 0;">' + printContents + '</div>'
    return printContents;
  }

  fnPaymentTemplate(payColl, fontfamily) {

    var printContents = ''
    if (payColl.length > 0) {
      printContents = this.fnLineTemplate()

      printContents = printContents + '<table style="width:100%;font-family:' + fontfamily + ';font-size: var(--font13);" cellspacing="0" cellpadding="0"><tbody>';


      var cashPayBO: any = {}
      var iscashpay = false

      for (let abo of payColl) {

        printContents = printContents + '<tr style="margin:0;padding:0;">' +
          '<td style="align="left">' + abo.paymentmodename + '</td>' +
          '<td align="right">' + this.aaNumber(abo.actualpaidamt) + '</td>' +
          '</tr>'
        if (abo.paymentmodename === 'Cash') {
          iscashpay = true;
          cashPayBO = abo
        }
      }
      if (iscashpay === true) {
        printContents = printContents + '<tr style="margin:0;padding:0;">' +
          '<td style="align="left">Received Amount</td>' +
          '<td align="right" style="font-weight:bold">' + this.aaNumber(cashPayBO.collectedamt) + '</td>' +
          '</tr>'

        printContents = printContents + '<tr style="margin:0;padding:0;">' +
          '<td style="align="left">Return Amount</td>' +
          '<td align="right">' + this.aaNumber(cashPayBO.balanceamt) + '</td>' +
          '</tr>'
      }

      printContents = printContents + '</tbody></table>';

      printContents = '<div style="width:100%;text-align:left;float:left;font-size:13;margin:0 0 2px 0;">' + printContents + '</div>'
    }
    return printContents;
  }

  fnPrinterOn(data, current_time) {
    var printContents = ''
    if (data.isclosed === 1) {
      printContents = 'Closed On : ' + data.closedon + '';
    }
    else {
      printContents = 'Printer On :' + current_time + ''
    }
    return printContents;
  }

  fnDuplicateHeader(data) {
    var printContents = ''
    if (data.printcopy > 0) {

      //  printContents = '<div style="font-size:12px;font-weight:500;margin:5px 0px 10px 0px">Duplicate</div>';
    }
    return printContents;
  }

  fnLogoHeader(data) {
    var printContents = ''
    if (data) {
      printContents = '<div style="margin:auto; text-align:center"><img src ="data:image/png;base64,' + data + '" height="80px" style="margin-left:5px;"></div>';
    }
    return printContents;
  }





  aaNumber(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number(total).toFixed(2)
    }
  }

  fnFormatInt(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number(total)
    }
  }


  fnFormatString(total) {

    if ( total === undefined || total === null) {
      return ''
    }
    else {
      return total
    }
  }


  fnaaFormatString(total) {

    if (total === undefined || total === null) {
      return ''
    }
    else {
      return total
    }
  }

}
